import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOMeta from '@/components/feature/SEOMeta';
import { userReviews } from '@/mocks/comments';
import { Link } from 'react-router-dom';

export default function About() {
  return (
    <>
      <SEOMeta
        title="关于我们 - 51黑料网 | 品牌介绍与联系方式"
        description="51黑料网致力于打造最全面的网红吃瓜、明星黑料、热门事件爆料平台。了解我们的品牌故事、平台口碑以及联系方式，欢迎爆料投稿与合作洽谈。"
        keywords="51黑料网,关于我们,品牌介绍,联系方式,爆料投稿,吃瓜平台"
        canonicalUrl="https://51heiliaowang.com/about"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于51黑料网',
            description: '51黑料网品牌介绍与联系方式',
            url: 'https://51heiliaowang.com/about',
            isPartOf: { '@type': 'WebSite', name: '51黑料网', url: 'https://51heiliaowang.com' },
          },
          {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://51heiliaowang.com' },
              { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://51heiliaowang.com/about' },
            ],
          },
          {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '如何向51黑料网投稿爆料？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '您可以通过页面底部的联系表单提交爆料信息，也可以发送邮件至我们的官方邮箱。我们承诺对爆料人信息严格保密，核实后的爆料内容将获得优先发布。',
                },
              },
              {
                '@type': 'Question',
                name: '51黑料网的内容真实性如何保证？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '我们拥有专业的采编团队，每一条爆料内容在发布前都会经过多方核实和交叉验证。对于无法完全核实的内容，我们会明确标注来源和信息可信度，让读者自行判断。',
                },
              },
            ],
          },
        ]}
      />

      <Navbar />

      <main>
        {/* Hero */}
        <section className="relative h-[420px] md:h-[500px] flex items-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Dark%20elegant%20abstract%20background%20with%20deep%20emerald%20green%20and%20charcoal%20gradient%2C%20mysterious%20atmospheric%20texture%2C%20subtle%20warm%20light%20accents%2C%20cinematic%20noir%20vibe%2C%20dark%20minimalist%20aesthetic%2C%20editorial%20quality%2C%20no%20text%2C%20no%20people&width=1920&height=900&seq=about-hero-01&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-top"
              aria-hidden="true"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
          </div>

          <div className="relative z-10 w-full px-6 md:px-10">
            <nav className="mb-4" aria-label="面包屑导航">
              <ol className="flex items-center gap-2 text-sm text-white/50">
                <li><Link to="/" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">首页</Link></li>
                <li><i className="ri-arrow-right-s-line text-xs"></i></li>
                <li className="text-white font-medium whitespace-nowrap">关于我们</li>
              </ol>
            </nav>

            <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-white leading-tight tracking-tight">
              关于
              <span className="text-accent-400">51黑料网</span>
            </h1>
            <p className="mt-4 text-base text-white/60 max-w-xl">
              打造最全面的吃瓜平台，让每一条爆料都触手可及
            </p>
          </div>

          <div className="absolute bottom-0 left-0 right-0 pointer-events-none">
            <p className="font-heading text-6xl md:text-8xl lg:text-9xl font-black text-white/6 leading-none tracking-tighter pl-6 md:pl-10 pb-4 md:pb-6 select-none whitespace-nowrap overflow-hidden">
              关于我们 · ABOUT US
            </p>
          </div>
        </section>

        {/* Brand Introduction & Stats */}
        <section className="bg-background-100 py-16 md:py-20">
          <div className="w-full px-6 md:px-10">
            <div className="max-w-4xl mx-auto">
              <div className="flex flex-col lg:flex-row lg:items-start gap-8 lg:gap-16">
                <div className="lg:w-1/3">
                  <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4 whitespace-nowrap">
                    关于平台
                  </span>
                  <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-950 leading-tight">
                    品牌介绍
                  </h2>
                </div>

                <div className="lg:w-2/3">
                  <div className="text-sm md:text-base text-foreground-600 leading-relaxed space-y-4">
                    <p>
                      51黑料网成立于2023年，是国内领先的娱乐资讯聚合平台之一。我们专注于为"吃瓜群众"提供最新、最快、最全的网红吃瓜、明星黑料与热门事件爆料内容。
                    </p>
                    <p>
                      我们的编辑团队由资深娱乐记者、网络文化研究者和数据分析师组成，全天候追踪娱乐圈与网红圈的动态，确保每一条资讯都能在第一时间触达用户。
                    </p>
                    <p>
                      平台独创"一区二区"内容分区体系——<strong>一区</strong>聚焦明星娱乐圈的劲爆内幕，<strong>二区</strong>专注网红达人圈的深度揭秘。无论你是想追最新的明星八卦，还是想看最劲爆的网红翻车，51黑料网都能满足你的吃瓜需求。
                    </p>
                    <p>
                      作为"吃瓜群众首选入口"，我们坚持<strong>真实、客观、快速</strong>的原则，每一条爆料都经过多方核实，力求为用户提供可信赖的资讯服务。同时，我们高度重视用户隐私保护，对爆料人的身份信息实施严格保密。
                    </p>
                  </div>
                </div>
              </div>

              {/* Stats */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mt-12 md:mt-16">
                <div className="text-center p-4 md:p-6 rounded-lg bg-background-50 border border-background-200/70">
                  <div className="text-2xl md:text-4xl font-black text-foreground-950 mb-1">30,000+</div>
                  <div className="text-xs md:text-sm text-foreground-400">爆料文章</div>
                </div>
                <div className="text-center p-4 md:p-6 rounded-lg bg-background-50 border border-background-200/70">
                  <div className="text-2xl md:text-4xl font-black text-foreground-950 mb-1">500+</div>
                  <div className="text-xs md:text-sm text-foreground-400">合作媒体</div>
                </div>
                <div className="text-center p-4 md:p-6 rounded-lg bg-background-50 border border-background-200/70">
                  <div className="text-2xl md:text-4xl font-black text-foreground-950 mb-1">98.7%</div>
                  <div className="text-xs md:text-sm text-foreground-400">用户满意度</div>
                </div>
                <div className="text-center p-4 md:p-6 rounded-lg bg-background-50 border border-background-200/70">
                  <div className="text-2xl md:text-4xl font-black text-foreground-950 mb-1">200万+</div>
                  <div className="text-xs md:text-sm text-foreground-400">日活用户</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* User & Media Reviews */}
        <section className="py-16 md:py-20" aria-labelledby="about-reviews-title">
          <div className="w-full px-6 md:px-10">
            <div className="mb-12">
              <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4 whitespace-nowrap">
                口碑评价
              </span>
              <h2 id="about-reviews-title" className="text-3xl md:text-5xl font-black text-foreground-950 leading-tight">
                网友与媒体
                <br />
                真实评价
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {userReviews.map((review) => (
                <article key={review.id} className="bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/70">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-full bg-background-200 overflow-hidden flex-shrink-0">
                      <img
                        src={review.avatar}
                        alt={review.name}
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                    </div>
                    <div>
                      <strong className="block text-sm font-semibold text-foreground-900">{review.name}</strong>
                      <span className="text-xs text-foreground-400">{review.username}</span>
                    </div>
                  </div>
                  <blockquote className="text-sm text-foreground-600 leading-relaxed">
                    &ldquo;{review.content}&rdquo;
                  </blockquote>
                  <div className="flex items-center gap-0.5 mt-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-xs ${i < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-200'}`}
                      ></i>
                    ))}
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* Contact & Submission */}
        <section className="bg-background-100 py-16 md:py-20" id="contact">
          <div className="w-full px-6 md:px-10">
            <div className="max-w-3xl mx-auto">
              <div className="text-center mb-10">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4 whitespace-nowrap">
                  联系我们
                </span>
                <h2 className="text-3xl md:text-5xl font-black text-foreground-950 mb-3">
                  爆料投稿与合作
                </h2>
                <p className="text-sm md:text-base text-foreground-500">
                  如果你有独家猛料或商业合作意向，欢迎通过以下方式联系我们
                </p>
              </div>

              {/* Contact Info Cards */}
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mb-10">
                <div className="bg-background-50 rounded-lg p-5 text-center border border-background-200/70">
                  <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                    <i className="ri-mail-line text-xl text-accent-600"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">爆料邮箱</h3>
                  <p className="text-xs text-foreground-500">tips@51heiliaowang.com</p>
                </div>
                <div className="bg-background-50 rounded-lg p-5 text-center border border-background-200/70">
                  <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                    <i className="ri-wechat-line text-xl text-secondary-600"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">微信公众号</h3>
                  <p className="text-xs text-foreground-500">51黑料网</p>
                </div>
                <div className="bg-background-50 rounded-lg p-5 text-center border border-background-200/70">
                  <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                    <i className="ri-shake-hands-line text-xl text-accent-600"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">商务合作</h3>
                  <p className="text-xs text-foreground-500">bd@51heiliaowang.com</p>
                </div>
              </div>

              {/* Contact Form */}
              <form
                data-readdy-form="true"
                id="about-contact-form"
                className="bg-background-50 rounded-lg p-6 md:p-8 border border-background-200/70"
                onSubmit={async (e) => {
                  e.preventDefault();
                  const form = e.currentTarget as HTMLFormElement;
                  const formData = new FormData(form);
                  const websiteAlt = (formData.get('website_alt') as string || '').trim();
                  if (websiteAlt) {
                    const msg = document.getElementById('contact-form-status');
                    if (msg) { msg.textContent = '提交成功！我们会尽快回复您。'; msg.className = 'text-sm text-accent-500 mt-3 text-center'; }
                    form.reset();
                    return;
                  }
                  try {
                    const res = await fetch('https://form.readdy.ai/submit', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                      body: new URLSearchParams({
                        name: formData.get('name') as string || '',
                        email: formData.get('email') as string || '',
                        subject: formData.get('subject') as string || '',
                        message: formData.get('message') as string || '',
                      }).toString(),
                    });
                    const text = await res.text();
                    let ok = false;
                    try { const p = JSON.parse(text); ok = res.ok && p?.code === 'OK'; } catch { ok = res.ok; }
                    const el = document.getElementById('contact-form-status');
                    if (el) {
                      el.textContent = ok ? '提交成功！我们会尽快回复您。' : '提交失败，请稍后再试。';
                      el.className = ok ? 'text-sm text-accent-500 mt-3 text-center' : 'text-sm text-red-500 mt-3 text-center';
                    }
                    if (ok) form.reset();
                  } catch {
                    const el = document.getElementById('contact-form-status');
                    if (el) { el.textContent = '网络错误，请稍后再试。'; el.className = 'text-sm text-red-500 mt-3 text-center'; }
                  }
                }}
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label htmlFor="contact-name" className="block text-xs font-medium text-foreground-600 mb-1.5">
                      姓名 <span className="text-red-400">*</span>
                    </label>
                    <input
                      id="contact-name"
                      type="text"
                      name="name"
                      required
                      className="w-full px-4 py-2.5 text-sm rounded-lg bg-background-100 border border-background-200/70 focus:outline-none focus:border-accent-400 text-foreground-800 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-email" className="block text-xs font-medium text-foreground-600 mb-1.5">
                      邮箱 <span className="text-red-400">*</span>
                    </label>
                    <input
                      id="contact-email"
                      type="email"
                      name="email"
                      required
                      className="w-full px-4 py-2.5 text-sm rounded-lg bg-background-100 border border-background-200/70 focus:outline-none focus:border-accent-400 text-foreground-800 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                </div>
                <div className="mb-4">
                  <label htmlFor="contact-subject" className="block text-xs font-medium text-foreground-600 mb-1.5">
                    主题 <span className="text-red-400">*</span>
                  </label>
                  <input
                    id="contact-subject"
                    type="text"
                    name="subject"
                    required
                    className="w-full px-4 py-2.5 text-sm rounded-lg bg-background-100 border border-background-200/70 focus:outline-none focus:border-accent-400 text-foreground-800 transition-colors"
                    placeholder="请选择：爆料投稿 / 商务合作 / 其他"
                  />
                </div>
                <div className="mb-5">
                  <label htmlFor="contact-message" className="block text-xs font-medium text-foreground-600 mb-1.5">
                    留言内容 <span className="text-red-400">*</span>
                  </label>
                  <textarea
                    id="contact-message"
                    name="message"
                    required
                    rows={5}
                    maxLength={500}
                    className="w-full px-4 py-2.5 text-sm rounded-lg bg-background-100 border border-background-200/70 focus:outline-none focus:border-accent-400 text-foreground-800 transition-colors resize-none"
                    placeholder="请详细描述您的爆料内容或合作意向（500字以内）"
                  ></textarea>
                </div>
                <input
                  type="text"
                  name="website_alt"
                  className="field-website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
                <button
                  type="submit"
                  className="w-full py-3 rounded-lg bg-secondary-500 hover:bg-secondary-600 text-white font-semibold text-sm cursor-pointer transition-all whitespace-nowrap"
                >
                  提交信息
                </button>
                <p id="contact-form-status" className="text-sm mt-3 text-center"></p>
              </form>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}